const EASE_SMOOTH = [0.22, 1, 0.36, 1];

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: EASE_SMOOTH },
};

const pageEntrance = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.4 },
};

const heroEntrance = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay, ease: EASE_SMOOTH },
});

const staggeredFadeInUp = (index, baseDelay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, delay: baseDelay + index * 0.1, ease: EASE_SMOOTH },
});

const staggeredHeroEntrance = (index, baseDelay = 0) => ({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, delay: baseDelay + index * 0.08, ease: EASE_SMOOTH },
});

export {
  EASE_SMOOTH,
  fadeInUp,
  pageEntrance,
  heroEntrance,
  staggeredFadeInUp,
  staggeredHeroEntrance,
};
